import { removeSpaces } from '../utils/remove-spaces';

export function camelCaseToPascalCase(text: string, options: { removeSpaces?: boolean } = {}): string {
    const { removeSpaces: shouldRemoveSpaces = true } = options;
    let result = text;
    if (shouldRemoveSpaces) {
        result = removeSpaces(result);
    }
    return result.charAt(0).toUpperCase() + result.slice(1);
}
